import { render } from "./MaterialSelect.vue?vue&type=template&id=e19473ee"
import script from "./MaterialSelect.vue?vue&type=script&lang=js"
export * from "./MaterialSelect.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__